/**
 * A processor for the was price push messages that can
 * update was price elements.
 *
 * @module app/components/WasPriceViewProcessor
 */
import _ from 'lodash';
import OddsFormatProvider from './OddsFormatProvider';

/**
 * check if selection has was price num & den and update it
 *
 * @param {Object} eventContainer jQuery element representing the event subscribed to enhanced odds
 * @param {Object} wasPriceWrapper jQuery element representing the selection was price wrapper
 * @param {Object} selection The selection object with was price numerator & denominator
 *
 * @returns {void}
 *
 * @private
 */
const updateSelectionWasPrice = (eventContainer, wasPriceWrapper, selection) => {

    if(selection.prices && selection.prices[0].priceNum && selection.prices[0].priceDen) {
        const newWasPrice = `${selection.prices[0].priceNum}/${selection.prices[0].priceDen}`;
        const hasPriceChanged =
          wasPriceWrapper.attr('data-denom') !== selection.prices[0].priceDen &&
          wasPriceWrapper.attr('data-num') !== selection.prices[0].priceNum;
        if (hasPriceChanged) {
            wasPriceWrapper.text(newWasPrice);
            wasPriceWrapper.attr('data-denom',selection.prices[0].priceDen);
            wasPriceWrapper.attr('data-num',selection.prices[0].priceNum);
            OddsFormatProvider.oddsConvert(false);
        }
    }
};

/**
 * Process was price
 *
 * @param {Object} eventContainer jQuery element representing the event subscribed to enhanced odds
 * @param {Object} data data
 *
 * @returns {void}
 *
 * @private
 */
const processWasPrice = (eventContainer, data) => {

    if (data.markets.length) {
        _.each(data.markets, (market) => {
            if(market.selections.length){
                _.each(market.selections, (selection) => {
                    if (selection.id) {
                        const selectionWasPriceWrapper = eventContainer.find('#was-price-' + selection.id);
                        updateSelectionWasPrice(eventContainer, selectionWasPriceWrapper, selection);
                    }
                });
            }
        });
    }
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
const api = {
    /**
   * Processor for the enhanced odds push messages that can
   * modify was price.
   *
   * @param {Object} eventContainer jQuery element
   * @param {Object} data data
   *
   * @returns {void}
   *
   * @public
   */
    setWasPrice: (eventContainer, data) => {

        const eventModel = window.WH.sportsbook.model.events[data.id];

        if (eventModel) {
            processWasPrice(eventContainer, data);
        }
    },
};

export default api;
